import React from 'react';


const OfflinePage = () => {
  return (
    <div className="offline-container">
      <h1>Oops! You're Offline</h1>
      <p>Please check your internet connection and try again.</p>
    </div>
  );
};

export default OfflinePage;
